import config from 'config/config'
import React from 'react'
import { Button } from 'semantic-ui-react'

class SelectLayout extends React.Component {
  render() {
    const dark = config.theme.dark

    const { toggleViewStyle, viewAsList } = this.props
    return (
      <Button.Group size="large">
        <Button
          inverted={dark}
          onClick={toggleViewStyle}
          disabled={viewAsList}
          icon="list layout"
        />
        <Button
          inverted={dark}
          onClick={toggleViewStyle}
          disabled={!viewAsList}
          icon="block layout"
        />
      </Button.Group>
    )
  }
}

export default SelectLayout



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/SelectLayout.jsx